function HelpModal() {
    return (<div className="modal fade" id="faq" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div className="modal-dialog">
      <div className="modal-content bg-dark">
        <div className="modal-header">
          <h5 className="modal-title" id="exampleModalLabel">Help!</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div className="modal-body">
          <h5>Setup:</h5>
          <p>Setup tutorials for homework, Skilldule Chats and exporting are available <a href="/setup">here</a>.</p>
          <h5>FAQ:</h5>
          <div className="accordion accordion-flush text-black" id="accordionExample">
            <div className="accordion-item">
              <h2 className="accordion-header" id="headingOne">
                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                  One of my classes isn't showing up.
                </button>
              </h2>
              <div id="collapseOne" className="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                <div className="accordion-body">
                  Please contact us at the email below and include the full name of the class as listed on the Parker Portal.
                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header" id="headingTwo">
                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                  My schedule reset!
                </button>
              </h2>
              <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                <div className="accordion-body">
                  This is most likely because you deleted the cookies associated with WIT&amp;SKILLDULE. To prevent further resetting, refrain from deleting Skilldule's cookies (because they are very tasty).
                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header" id="headingThree">
                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                  How do I find lunches?
                </button>
              </h2>
              <div id="collapseThree" className="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
                <div className="accordion-body">
                  To get more information about different classes/blocks click on the tiles.
                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header" id="headingFour">
                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseTwo">
                  Who started the fire?
                </button>
              </h2>
              <div id="collapseFour" className="accordion-collapse collapse" aria-labelledby="headingFour" data-bs-parent="#accordionExample">
                <div className="accordion-body">
                  Ryan started the fire.
                </div>
              </div>
            </div>
          </div>
          <div className="border-top my-3" />
          <h5>Contact Us:</h5>
          <p>Email: <a href="mailto:jadee@fwparker.org">Jack Adee</a></p>
          <div className="text-center"><button className="btn btn-primary" data-bs-dismiss="modal">OK</button></div>
        </div>
      </div>
    </div>
  </div>)
}

export default HelpModal;